// import jwtDecode from 'jwt-decode'
import AuthProvider from '@/resources/AuthProvider'

const authService = new AuthProvider()

const state = {
  id: null,
  firstName: null,
  lastName: null,
  email: null,
  role: null,
  imageUrl: null,
  tokenExpire: null,
  accessToken: null
}

const actions = {
  async login ({ dispatch }, payload) {
    const response = await authService.login({
      email: payload.email,
      password: payload.password
    })
    if (response?.accessToken) {
      dispatch('setUser', {
        id: response?.data?.id || null,
        firstName: response?.data?.firstName || null,
        lastName: response?.data?.lastName || null,
        email: response?.data?.email || null,
        role: response?.data?.role || null,
        imageUrl: response?.data?.imageUrl || null,
        tokenExpire: response?.data?.tokenExpire || null,
        accessToken: response?.accessToken || null
      })
    } else {
      const error = {
        statusCode: 400,
        message: 'Access token not found.'
      }
      throw error
    }
  },
  setUser ({ commit }, payload) {
    commit('SET_USER', payload)
  },
  resetUser ({ commit }) {
    commit('RESET_USER')
  },
  setImageUrl ({ commit }, payload) {
    commit('SET_IMAGE_URL', payload)
  },
  setName ({ commit }, payload) {
    commit('SET_NAME', payload)
  }
}

const mutations = {
  SET_NAME (state, payload) {
    state.firstName = payload.firstName
    state.lastName = payload.lastName
    state.email = payload.email
  },
  SET_IMAGE_URL (state, payload) {
    state.imageUrl = payload
  },
  SET_USER (state, payload) {
    state.id = payload.id
    state.firstName = payload.firstName
    state.lastName = payload.lastName
    state.email = payload.email
    state.role = payload.role
    state.imageUrl = payload.imageUrl
    state.tokenExpire = payload.tokenExpire
    state.accessToken = payload.accessToken
  },
  RESET_USER (state) {
    state.id = null
    state.firstName = null
    state.lastName = null
    state.email = null
    state.role = null
    state.imageUrl = null
    state.tokenExpire = null
    state.accessToken = null
  }
}

const getters = {
  user: (state) => ({ ...state }),
  accessToken: (state) => state.accessToken,
  tokenExpire: (state) => state.tokenExpire,
  role: (state) => state.role
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
